import { formatLocaleDateString } from "helpers/utils";

import type { IFinanceGridChannel, IFinanceGridPriceEntry } from "./types";

export const channelKey = (channel: IFinanceGridChannel): number | "default" => channel.channelId ?? "default";

export const entryStatus = (e: IFinanceGridPriceEntry): "past" | "current" | "future" =>
    e.status ?? (e.endDate ? "past" : "current");

export const formatGridPrice = (cents: number, currency: string) =>
    (cents / 100).toLocaleString("fr-FR", { style: "currency", currency });

export const formatDate = (date: string | null) =>
    date ? formatLocaleDateString({ date, options: { numeric: true, timeZone: "UTC" } }) : "—";

/** Period label for the read-only grid; null when dates are open-ended and the status badge is enough. */
export const formatPeriodLabel = (entry: IFinanceGridPriceEntry, openEndedLabel: string): string | null => {
    const { startDate, endDate } = entry;

    if (!startDate && !endDate) return null;
    if (startDate && !endDate) return `${formatDate(startDate)} → ${openEndedLabel}`;
    if (!startDate && endDate) return `→ ${formatDate(endDate)}`;

    return `${formatDate(startDate)} → ${formatDate(endDate)}`;
};
